import Accordion from "@/components/Accordion";
import {useAppState} from "@/store";
import {parseMergeTags} from "@/helpers";

export default function FaqGrid() {
    const content = window.ein?.content?.step_5 || {}
    const {faq_grid} = content
    const {state} = useAppState()
    return (
        <>
            <div className="heading-h2 text-center mb-[16px]">
                {parseMergeTags(faq_grid?.heading, state)}
            </div>
            <div className="text-big text-center mb-[32px]">
                {parseMergeTags(faq_grid?.subheading, state)}
            </div>
            <div className={"grid grid-cols-1 lg:grid-cols-3 gap-[16px] lg:gap-[32px]"}>
                {faq_grid?.faqs && faq_grid.faqs.map((faq, i) => (
                    <Accordion key={i} title={parseMergeTags(faq.question, state)} content={parseMergeTags(faq.answer, state)} />
                ))}
            </div>
        </>
    )
}
